import { NgModule } from '@angular/core';
import { TapesBackend } from './tapes.backend';
import { TapesService } from './tapes.service';

@NgModule({
  providers: [TapesService, TapesBackend],
})
export class TapesModule {}
